/* eslint-disable max-len */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Drawer from '@quintoandar/cozy-core/Drawer';
import Tag from '@quintoandar/cozy-core/Tag';
import Box from '@quintoandar/cozy-core/Box';
import Typography from '@quintoandar/cozy-core/Typography';
import tokens from '@quintoandar/cozy-theme/tokens/js';
import Button from '@quintoandar/cozy-core/Button';
import Carousel from '@quintoandar/cozy-core/Carousel';
import ArrowBack from '@quintoandar/cozy-icons/ArrowBack';
import ArrowForward from '@quintoandar/cozy-icons/ArrowForward';
import {
  getKeyFromLocalStorage,
  setKeyToLocalStorage,
} from '@quintoandar/fwp-storage';

const ONBOARDING_ALREADY_SEEN = 'ONBOARDING_ALREADY_SEEN';

const ClickableBox = styled(Box)`
  cursor: pointer;
`;

const Onboarding = ({ dataToOnboarding, onboardingReference, btnTextFinish }) => {
  const [openDrawer, setOpenDrawer] = useState(true);
  const [currentStep, setCurrentStep] = useState(0);
  const [btnDisabled, setBtnDisabled] = useState(true);

  const ONBOARDING_NAME = `${ONBOARDING_ALREADY_SEEN}_${onboardingReference}`;

  const onCloseModal = useCallback(() => {
    setOpenDrawer(false);
    setOnboardingAlreadySeen();
  });

  const onClickArrowBack = useCallback(() => {
    if (currentStep > 0) {
      setCurrentStep(step => step - 1);
    }
  });

  const onClickArrowForward = useCallback(() => {
    if (currentStep < dataToOnboarding.length - 1) {
      setCurrentStep(step => step + 1);
    }
  });

  const onboardingAlreadySeen = () => getKeyFromLocalStorage(ONBOARDING_NAME) === 'true';

  const setOnboardingAlreadySeen = () => setKeyToLocalStorage(ONBOARDING_NAME, true);

  useEffect(() => {
    if (currentStep === dataToOnboarding.length - 1) {
      setBtnDisabled(false);
    }
  });

  return <>{!onboardingAlreadySeen() ? <>
    <Drawer
      open={openDrawer}
      anchor="bottom"
    >
      <Box
        pt={tokens.alias.spacing.xxlarge}
        pb={tokens.alias.spacing.large}
        px={tokens.alias.spacing.small}
        maxWidth="450px"
        width="100%"
        m="auto"
      >
        <Carousel swipe maxNumberOfDots={5} pagination onChange={setCurrentStep} initialIndex={currentStep}>
          {
            dataToOnboarding.map(onboarding => (
              <Box>
                <Box pb={tokens.alias.spacing.hsmall}>
                  {onboarding.tag && onboarding.tag.icon
                    ? <Tag
                      kind={onboarding.tag.kind}
                      label={onboarding.tag.label}
                      // eslint-disable-next-line react/jsx-no-bind
                      icon={() => onboarding.tag.icon}
                    />
                    : null}
                </Box>
                <Typography level="heading" pb={tokens.alias.spacing.hsmall}>
                  <FormattedMessage {...onboarding.title} />
                </Typography>
                <Typography level="body" pb={tokens.alias.spacing.hsmall}>
                  <FormattedMessage {...onboarding.description} />
                </Typography>
              </Box>
            ))
          }
        </Carousel>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          pt={tokens.alias.spacing.xhuge}
        >
          <ClickableBox>
            <ArrowBack
              onClick={onClickArrowBack}
              color={currentStep === 0 ? 'disabled' : 'inherit'}
            />
          </ClickableBox>
          <Box display="flex" >
            {dataToOnboarding.map((_, index) =>
              <Box
                mx={tokens.alias.spacing.hxxsmall}
                // eslint-disable-next-line react/jsx-no-bind
                onClick={() => setCurrentStep(index)}
                bgcolor={currentStep === index ? tokens.alias.color.surface.interaction.default : tokens.alias.color.surface.interaction.disabled}
                borderRadius="50%"
                width="8px"
                height="8px"
              ></Box>
            )}
          </Box>
          <ClickableBox>
            <ArrowForward
              onClick={onClickArrowForward}
              color={currentStep === dataToOnboarding.length - 1 ? 'disabled' : 'inherit'}
            />
          </ClickableBox>
        </Box>

        <Box pt={tokens.alias.spacing.small}>
          <Button
            variant="special"
            disabled={btnDisabled}
            fullWidth
            onClick={onCloseModal}
          >
            {btnTextFinish}
          </Button>
        </Box>
      </Box>
    </Drawer>

  </> : null}</>;
};

Onboarding.propTypes = {
  dataToOnboarding: PropTypes.array,
  onboardingReference: PropTypes.string,
};

export default Onboarding;
